import { ChatBotView } from "../chatBot/views/ChatBotView";
function ChatBot() {
  return <ChatBotView />;
}

export default ChatBot;
